import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss'],
})
export class RegisterSuccessComponent {
  constructor(public dialogRef: MatDialogRef<RegisterSuccessComponent>) {}

  onClose() {
    document.getElementsByClassName('animate__animated')[0].classList.remove('animate__fadeInDown');
    document.getElementsByClassName('animate__animated')[0].classList.add('animate__fadeOutDown');
    setTimeout(() => {
      this.dialogRef.close();
    }, 500);
  }
}
